var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.292 18.9478L19.5087 21.1641C19.9653 21.621 20.7071 21.621 21.1642 21.1641C21.6213 20.7071 21.6213 19.9652 21.1642 19.5082L18.948 17.292C18.491 16.835 17.7491 16.835 17.292 17.292C16.8353 17.7489 16.8353 18.4909 17.292 18.9478ZM2.67027 2.67001C-0.890091 6.23008 -0.890091 12.0107 2.67027 15.5709C6.23015 19.1309 12.0109 19.1309 15.5713 15.5709C19.1311 12.0107 19.1311 6.23008 15.5713 2.67001C12.0109 -0.890003 6.23015 -0.890003 2.67027 2.67001ZM4.32585 4.32585C6.97246 1.67965 11.2691 1.67965 13.9152 4.32585C16.5613 6.97207 16.5613 11.2688 13.9152 13.915C11.2691 16.5612 6.97246 16.5612 4.32585 13.915C1.67973 11.2688 1.67973 6.97207 4.32585 4.32585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.06edcc09bb523f8b070c48ca1009d891.svg";
export { ForwardRef as ReactComponent };